import { getUserRoleEntryByRoleId } from '../utils/userRoles';
import { PermissionLevelProps, PermissionRolesProps } from '../types/permissions';
import { permissionLevelsCatalog } from '../constants/permissions';
import { RootState, useAppSelector } from '../redux/store';
import { useMemo } from 'react';
import { UserRoles } from '../types/user-roles';

export const usePermissions = (): {
  isAllowed: (props: PermissionLevelProps | PermissionRolesProps) => boolean;
  isReadOnlyUser: boolean;
} => {
  const authState = useAppSelector((state: RootState) => state.auth);

  const getUserRole = () => {
    if (!authState.authContext?.securityLevelId) return undefined;

    if (authState.isOwner) return UserRoles.OWNER;

    return getUserRoleEntryByRoleId(Number(authState.authContext.securityLevelId))?.role;
  };

  const isAllowed = useMemo(() => {
    return (props: PermissionLevelProps | PermissionRolesProps) => {
      const userRole = getUserRole();

      if (props.allowedRoles) {
        return Array.isArray(props.allowedRoles)
          ? props.allowedRoles.includes(userRole as UserRoles)
          : userRole === props.allowedRoles;
      } else if (props.allowedPermissionLevels) {
        return permissionLevelsCatalog[props.allowedPermissionLevels].includes(
          userRole as UserRoles,
        );
      } else {
        return false;
      }
    };
  }, [authState.authContext, authState.isOwner]);

  const isReadOnlyUser = useMemo(() => {
    return authState.authContext?.readOnly !== false;
  }, [authState.authContext]);

  return { isAllowed, isReadOnlyUser };
};
